import { useQuery, useMutation } from "react-query";
import { toast } from "react-toastify";
import { BrochureServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Brochure Master section
 */
const useListBrochure = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(["brochure-list", page_no], BrochureServices.brochureList, {
    onSuccess,
    keepPreviousData: true,
    onError,
  });
};
const useAddBrochure = (onSuccess, onError = onDefaultError) => {
  return useMutation(BrochureServices.addBrochure, {
    onSuccess,
    onError,
  });
};
const useUpdateBrochure = (onSuccess, onError = onDefaultError) => {
  return useMutation(BrochureServices.updateBrochure, {
    onSuccess,
    onError,
  });
};
const useViewBrochure = (id, onSuccess, onError = onDefaultError) => {
  return useQuery("manual-view", () => BrochureServices.viewBrochure({ id }), {
    onSuccess,
    onError,
  });
};
const useBrochureDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(BrochureServices.deleteBrochure, {
    onSuccess,
    onError,
  });
};
const useBrochureDeletePdfIT = (onSuccess, onError = onDefaultError) => {
  return useMutation(BrochureServices.deleteBrochurePdfIT, {
    onSuccess,
    onError,
  });
};
const useBrochureDeletePdfDE = (onSuccess, onError = onDefaultError) => {
  return useMutation(BrochureServices.deleteBrochurePdfDE, {
    onSuccess,
    onError,
  });
};
export {
  useListBrochure,
  useAddBrochure,
  useUpdateBrochure,
  useViewBrochure,
  useBrochureDelete,
  useBrochureDeletePdfIT,
  useBrochureDeletePdfDE,
};
